module.exports = __webpack_public_path__ + "static/media/card-Charlie-handsFree.be3ffb54.svg";